/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

// Angular port of the AngularJS ActivityService. Feed methods resolve to `{ data, headers }` so they plug
// straight into FeedStoreService, which reads the X-Next-Page header.
@Injectable({ providedIn: 'root' })
export class ActivityService {
  constructor(private http: HttpClient) {}

  feed(params: any): Promise<any> {
    return this.page('/api/v1/activities', params);
  }

  communityActivities(params: any): Promise<any> {
    return this.page('/api/v1/activities/community', params);
  }

  projectActivities(params: any): Promise<any> {
    return this.page('/api/v1/activities/projects', params);
  }

  clearAll(): Promise<any> {
    return firstValueFrom(this.http.put<any>('/api/v1/activities/clear_all', ''));
  }

  private page(url: string, params: any): Promise<any> {
    const query = { page: 1, per_page: 10, ...params };
    return firstValueFrom(this.http.get<any[]>(url, { observe: 'response', params: query }))
      .then((response) => ({
        data: response.body,
        headers: (name: string) => response.headers.get(name),
      }));
  }
}
